export const GET_MENU_ITEMS = 'sidebar-configuration/GET_MENU_ITEMS';
export const GET_MODULE_INFO = 'sidebar-configuration/GET_MODULE_INFO';
export const SET_SELECTED_MODULE = 'sidebar-configuration/SET_SELECTED_MODULE';
export const SET_SELECTED_FOLDER = 'sidebar-configuration/SET_SELECTED_FOLDER';
export const SET_SELECTED_TABLE = 'sidebar-configuration/SET_SELECTED_TABLE';
export const SET_SELECTED_MODULE_NAME = 'sidebar-configuration/SET_SELECTED_MODULE_NAME';
export const SET_LOADING_STATE = 'sidebar-configuration/SET_LOADING_STATE';
export const SET_MODULE_CONFIGURATION = 'sidebar-configuration/SET_MODULE_CONFIGURATION';
export const SET_TABLE_LIST =  'sidebar-configuration/SET_TABLE_LIST';
export const SET_FOLDERS_LIST_WITH_EXCEPTIONS =  'sidebar-configuration/SET_FOLDERS_LIST_WITH_EXCEPTIONS';
export const UPDATE_TAGS_LIST = 'sidebar-configuration/UPDATE_TAGS_LIST';
export const ADD_TAG_TO_TAGS_LIST = 'sidebar-configuration/ADD_TAG_TO_TAGS_LIST';
export const REMOVE_TAG_FROM_TAGS_LIST = 'sidebar-configuration/REMOVE_TAG_FROM_TAGS_LIST';